import { useEffect, useMemo, useState, memo } from 'react';
import useCountdownInterval from '@/hooks/useCountdownInterval';
import classNames from 'classnames';
import Marquee from 'react-fast-marquee';

const MarqueeText = memo(({ text }: { text: string }) => {
  return <span className="px-4">{text}</span>;
});

const LobbyAlert = ({ text, type, endDate }: { text: string; type: string; endDate?: string | null }) => {
  const [alertColorRgb, setAlertColorRgb] = useState([227, 157, 2]);

  const { timeLeft } = useCountdownInterval(endDate ? new Date(endDate) : new Date());

  useEffect(() => {
    let color;
    switch (type) {
      case 'green':
        color = [23, 178, 106];
        break;
      case 'orange':
        color = [227, 157, 2];
        break;
      case 'red':
        color = [197, 69, 40];
        break;
      case 'purple':
        color = [169, 88, 215];
        break;
      default:
        color = [169, 88, 215];
        break;
    }
    setAlertColorRgb(color);
  }, [type]);

  const alertColor = (opacity: number = 1) => {
    return `rgba(${alertColorRgb[0]}, ${alertColorRgb[1]}, ${alertColorRgb[2]}, ${opacity})`;
  };

  if (!text) {
    return null;
  }

  return (
    <div
      style={{ backgroundColor: alertColor(0.1) }}
      className="position-relative w-100 h-[40px] rounded bg-opacity-10 px-3 py-2 text-center"
    >
      <div className="w-100 flex h-full items-center justify-center gap-2">
        <div className="d-flex w-100 align-items-center justify-content-between relative h-full flex-row gap-2">
          <span
            className="d-flex justify-content-start relative h-full w-full flex-row gap-2 overflow-hidden"
            style={{ flex: 1 }}
          >
            <span style={{ color: alertColor() }} className="w-100 font-bold">
              <Marquee pauseOnHover autoFill className="w-100">
                <span className="px-4">{text}</span>
              </Marquee>
            </span>
          </span>
          {endDate && (
            <p
              style={{
                width: 'auto',
                color: alertColor(),
                fontFamily: 'Nunito Sans',
                zIndex: 100000,
              }}
              className="align-items-middle font-nunito m-0 text-end text-base font-bold"
            >
              {timeLeft}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default LobbyAlert;
